import { Assets } from 'pixi.js'
import hs_history_click from '../../../asset/images/menu/history_click.png'
import hs_history_hover from '../../../asset/images/menu/history_hover.png'
import hs_history_normal from '../../../asset/images/menu/history_normal.png'
import hs_history_disabled from '../../../asset/images/menu/history_unable.png'
import { ButtonProps } from './interface/ButtonProps'
import {
  betHistoryService,
  Button,
  Ga4EventType,
  ga4Info,
  soundManager,
  SoundType,
  useBetHistoryStore,
} from '@slot-nx/core'

Assets.addBundle('BetHistoryButton', {
  hs_history_click: { src: hs_history_click, loadParser: 'loadTextures' },
  hs_history_hover: { src: hs_history_hover, loadParser: 'loadTextures' },
  hs_history_normal: { src: hs_history_normal, loadParser: 'loadTextures' },
  hs_history_disabled: { src: hs_history_disabled, loadParser: 'loadTextures' },
})

export const BetHistoryButton = (props: ButtonProps) => {
  return (
    <Button
      name="Bet History Button"
      defaultView="hs_history_normal"
      hoverView="hs_history_hover"
      pressedView="hs_history_click"
      disabledView="hs_history_disabled"
      enabled={!props.disabled}
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      onPressing={() => {
        soundManager.play(SoundType.buttonConfirm)
      }}
      onPress={() => {
        betHistoryService.getBetList()
        useBetHistoryStore.setState({
          isOpened: true,
        })
        ga4Info.addEvent(Ga4EventType.menu_history)
      }}
    />
  )
}
